import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { MdDeleteForever } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import Navbar from "../Navbar";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { FaArrowRightLong } from "react-icons/fa6";
import { SiGitconnected } from "react-icons/si";
import { MdAddToPhotos } from "react-icons/md";
import Menu_Items from "../Menu_Items";

function Bound() {
  const { id } = useParams();
  const [Add_Integ, setAdd_Integ] = useState(false)
  const [su_admin, setsu_admin] = useState(false)
  const [admin, setadmin] = useState(false)
  const [spl, setspl] = useState(false)
  const [sortOrder, setSortOrder] = useState("asc"); // Track sorting order
  const [sortedData, setSortedData] = useState([]); // Store sorted data
  const [delete_box, setdelete_box] = useState(false);
  const [delete_id, setdelete_id] = useState(null)
  const [deleted, setdeleted] = useState(false)

  const menus = [
    (su_admin || admin ? { name: 'Integrations', id } : { name: null, id }),
    (su_admin || admin ? { name: 'Users', id } : { name: null, id })
  ];
  const getinteg = async () => {
    await axios
      .get(`/integ/${id}`)
      .then(async (res) => {
        let values = res.data;
        if (values.length !== 0) {
          setSortedData(values);
          await axios.get(`/company/${id}`).then((res) => {
            if (res.data.no_integration > values.length) {
              setAdd_Integ(true);
            } else {
              setAdd_Integ(false);
            }
          });
        } else {
          setAdd_Integ(true);
        }
      })
      .catch((err) => {
        toast.error("Records Couldn't be Fetched", {
          autoClose: 2000, // 2 seconds
        });
      });
  };
  const deleteinteg = async () => {
    setdeleted(preData => !preData)
    await axios.delete(`/integ/delete/${delete_id}`).then((res) => {
      setdeleted(preData => !preData)
    })
      .catch((err) => {
        toast.error("Records Couldn't be Deleted", {
          autoClose: 2000, // 2 seconds
        });
      });

  };
  // Function to handle sorting
  const handleSort = (name) => {
    const newOrder = sortOrder === "asc" ? "desc" : "asc"; // Toggle order
    const sorted = [...sortedData].sort((a, b) => {
      if (typeof a[name] === "string") {
        return newOrder === "asc"
          ? a[name].localeCompare(b[name])
          : b[name].localeCompare(a[name]);
      } else {
        return newOrder === "asc" ? a[name] - b[name] : b[name] - a[name]; // Numerical sorting
      }
    });
    setSortedData(sorted);
    setSortOrder(newOrder);
  };
  const get_level = () => {
    const level = Cookies.get("level");
    if (level === "Super Admin") {
      setsu_admin(true);
    }
    else if (level === 'Admin') {
      setadmin(true)
    }
    else if (level === 'Integ Special') {
      setspl(true)
    }

  };
  useEffect(() => {
    getinteg();
    get_level();
    setdelete_id(null)
    setdelete_box(false)
  }, [deleted]);

  return (
    <div className="container df fdc jc ac">
      <Navbar />
      <div className='main_box df'>
        <Menu_Items menu={menus} />
        <div className='content df fdc ac'>
          <div className='page_header df jb ac'>
            <div className='w90 df ac'><SiGitconnected className='page_icon db' />
              <p>Integration</p></div>
            {
              Add_Integ && (su_admin || admin || spl) && (<Link to={`/integ/add/${id}`} className='w5' ><MdAddToPhotos className='icon3 g' /></Link>)
            }
          </div>
          <table className="df fdc ac box">
            <thead>
              <tr className="df js ac" style={{ cursor: "pointer" }}>
                <th onClick={() => { handleSort('name') }}>Integration Name {sortOrder === "asc" ? "▲" : "▼"}</th>
                <th onClick={() => { handleSort('dbtype') }}>Database Type {sortOrder === "asc" ? "▲" : "▼"}</th>
                <th onClick={() => { handleSort('db') }}>Database Name {sortOrder === "asc" ? "▲" : "▼"}</th>
                <th onClick={() => { handleSort('c_type') }}>Type {sortOrder === "asc" ? "▲" : "▼"}</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.length > 0 && (
                sortedData.map((data, index) => {
                  return (
                    <tr className="df js ac" key={index} style={{ cursor: "pointer" }}>
                      <td className="df jc ac">{data.name}</td>
                      <td className="df jc ac">{data.dbtype}</td>
                      <td className="df jc ac">{data.db}</td>
                      <td className="df jc ac">{data.c_type}</td>
                      <td className="df jc ac gap2">
                        {data.c_type === "In Bound" && (
                          <Link to={`/in_bound_details/${id}/${data.id}`} className="tooltip" icon-name="In Bound"><FaArrowRightLong className="icon2 db" /></Link>
                        )}
                        {data.c_type === "Out Bound" && (
                          <Link to={`/out_bound_details/${id}/${data.id}`} className="tooltip" icon-name="Out Bound"><FaArrowRightLong className="icon2 db" /></Link>
                        )}
                        {(su_admin || admin || spl) && (
                          <>
                            <Link to={`/bound/edit/${id}/${data.id}`} className="tooltip" icon-name="Edit"><FaEdit className="icon2 db" /></Link>
                            <Link to={`#`} className="tooltip" icon-name="Delete"><MdDeleteForever className="icon2 r" onClick={() => { setdelete_box(true); setdelete_id(data.id) }} /></Link>
                          </>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
              {sortedData.length === 0 &&
                <tr className="h65 df jc ac bnone">
                  <td className="w100 bnone tac no_Records">No Records</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      {/* <div className="h_btn df jc ae">
        <p className="df jc ac">Integration</p>
        <div className="menu_bar h5 w15 df je ac gap1">
          <Link to={home_path} className="menu_icon df jc ac">
            <AiFillHome className="icon2" />
          </Link>
          {admin_level && (
            <Link to={`/company/users/${id}`} className="menu_icon df jc ac">
              <FaUsers className="icon2" />
            </Link>
          )}
          {((admin_level && Add_Integ) || (user_level && Add_Integ)) && (
            <Link to={`/integ/add/${id}`} className="menu_icon df jc ac">
              <BsDatabaseFillAdd className="icon2" />
            </Link>
          )}
          <Link to={"/"} className="menu_icon df jc ac">
            <MdLogout className="icon2" />
          </Link>
        </div>
      </div> */}
      {
        delete_box &&
        <div className='dialog_bg'>
          <div className='delete_box'>
            <h1 className='h5 w80 df ac r'>Delete</h1>
            <p className='h5 w80'>Are You Sure You Want to Delete This Item ?</p>
            <div className='h5 w40 df jb ac'>
              <button className='btn l_black' onClick={() => setdelete_box(false)}>Cancel</button>
              <button className='btn red' onClick={() => deleteinteg()}>Delete</button>
            </div>
          </div>
        </div>
      }
    </div >
  );
}

export default Bound;
